import { useTranslation } from "react-i18next";

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <span className="inline-block px-3 py-1 bg-background-200 text-foreground-600 rounded-full text-xs font-medium mb-8">
          {t("stats.label")}
        </span>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/2">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-serif">
              {t("stats.intro")}
            </p>
          </div>

          <div className="lg:w-1/2 grid grid-cols-2 gap-x-16 gap-y-10">
            <div>
              <span className="text-4xl md:text-5xl font-black text-foreground-900">{t("stats.stat1.value")}</span>
              <p className="mt-1 text-xs text-foreground-500">{t("stats.stat1.label")}</p>
            </div>
            <div>
              <span className="text-4xl md:text-5xl font-black text-foreground-900">
                {t("stats.stat2.value")}
                <sup className="text-lg font-normal text-foreground-500 ml-0.5">{t("stats.stat2.label_sup")}</sup>
              </span>
              <p className="mt-1 text-xs text-foreground-500">{t("stats.stat2.label_sub")}</p>
            </div>
            <div>
              <span className="text-4xl md:text-5xl font-black text-foreground-900">{t("stats.stat3.value")}</span>
              <p className="mt-1 text-xs text-foreground-500">{t("stats.stat3.label")}</p>
            </div>
            <div>
              <span className="text-4xl md:text-5xl font-black text-foreground-900">{t("stats.stat4.value")}</span>
              <p className="mt-1 text-xs text-foreground-500">{t("stats.stat4.label")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}